import React, { useState } from "react";
import { Button, TextField, Box } from "@material-ui/core";
import ServiceAPI from "../../../../service/ServiceAPI";
import InventoryGalleryModel from "../../../../model/InventoryGalleryModel";
import { makeStyles } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import PublishIcon from '@material-ui/icons/Publish';
import InventoryImage from "../../../utils/InventoryImage";
import Constants from "../../../../utils/Constants";

const useStyles = makeStyles({
  container: {
    width: '300px',
    height: '100%',
    margin: '1em auto',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'space-between',
    justifyContent: 'space-between'
  },
  imagePlaceholder: {
    width: '300px',
    minHeight: '300px',
    border: '1px solid gray',
    alignContent: 'center'
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between'
  }
});

const AddToGalleryView = function(props) {
  console.assert(props.workflowViews);
  console.assert(props.setWorkflowView);

  const cssClasses = useStyles();

  const [imageBase64, setImageBase64] = useState("");
  const [description, setDescription] = useState("");

  /**
   * 
   * @param {*} event 
   * @returns 
   */
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const img = new Image();
      img.src = reader.result;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        
        if (img.width > img.height) { // Scale by width
          const scaleFactor = Constants.Misc.ImageSizePx / img.width;
          canvas.width =  Constants.Misc.ImageSizePx;
          canvas.height = img.height * scaleFactor;
        } else { // Scale by height instead    
          const scaleFactor =  Constants.Misc.ImageSizePx / img.height;
          canvas.width = img.width * scaleFactor;
          canvas.height =  Constants.Misc.ImageSizePx; 
        }

        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        setImageBase64(canvas.toDataURL());
      };
    };
  };

  /**
   * Uploads the image to the API
   */
  const handleClick_uploadImage = () => {
    let image = new InventoryGalleryModel();
    image.setDescription(description);
    image.setImage(imageBase64.split(",")[1]);
    
    ServiceAPI.InventoryGallery().addNewImage(image).then( (data) => {
      props.setWorkflowView(props.workflowViews.Gallery);
    })
  }

  
  const render = () => {
    
    return (
      <Box className={cssClasses.container}>
        <h3>Add image to the Gallery</h3>
        <InventoryImage 
          base64Image={ imageBase64 } 
          alt={description}
        />
        <input type="file" accept="image/*" onChange={handleFileUpload} />
        <TextField 
          value={description} onChange={(e) => setDescription(e.currentTarget.value)} 
          label="Image description" 
          variant="outlined"
        />
        <Box className={cssClasses.actions}>
          <Button variant="contained" color="default" size="large" startIcon={<CloseIcon />} onClick={() => props.setWorkflowView(props.workflowViews.Gallery) }>
            Cancel
          </Button>

          <Button variant="contained" color="primary" size="large" startIcon={<PublishIcon />} onClick={handleClick_uploadImage}>
            Upload
          </Button>
        </Box>
      </Box>
    );
  }

  return render();
}

export default AddToGalleryView; 